"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var helper_1 = require("../../utils/helper");
var theme_1 = require("../../utils/theme");
var Radio = (function (_super) {
    tslib_1.__extends(Radio, _super);
    function Radio() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            checked: Boolean(_this.props.defaultChecked)
        };
        _this.handleChange = function (e, forceCheck) {
            var props = _this.props;
            if (props.disabled) {
                return;
            }
            var checked = forceCheck !== null && forceCheck !== void 0 ? forceCheck : e.target.checked;
            if (!('checked' in props)) {
                _this.setState({
                    checked: checked
                });
            }
            props.onChange(checked, {
                target: tslib_1.__assign(tslib_1.__assign({}, props), { checked: checked }),
                stopPropagation: e.stopPropagation.bind(e),
                preventDefault: e.preventDefault.bind(e),
                nativeEvent: e.nativeEvent
            });
        };
        _this.handleClick = function (e) {
            if (_this.isChecked) {
                return;
            }
            _this.handleChange(e, true);
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, children = _c.children, disabled = _c.disabled, hollow = _c.hollow, labelClassName = _c.labelClassName, labelStyle = _c.labelStyle, iconClassName = _c.iconClassName, iconStyle = _c.iconStyle, labelClickable = _c.labelClickable, rest = tslib_1.__rest(_c, ["prefixCls", "className", "style", "children", "disabled", "hollow", "labelClassName", "labelStyle", "iconClassName", "iconStyle", "labelClickable"]);
            var checked = _this.isChecked;
            var cls = classNames(prefixCls, className, prefixCls + "-" + (hollow ? 'hollow' : 'normal'), (_a = {},
                _a[prefixCls + "-multi-line"] = React.Children.count(children) > 1,
                _a[prefixCls + "-checked"] = checked,
                _a[prefixCls + "-disabled"] = disabled,
                _a));
            var inputCls = classNames(prefixCls + "-input", (_b = {},
                _b[prefixCls + "-input-full"] = labelClickable,
                _b));
            var iconCls = classNames(prefixCls + "-icon", iconClassName);
            var labelCls = classNames(prefixCls + "-label", labelClassName);
            return (h("div", { className: cls, style: style },
                h("span", { className: iconCls, style: iconStyle, onClick: _this.handleClick }),
                h("div", { className: labelCls, style: labelStyle }, children),
                h("input", tslib_1.__assign({}, rest, { type: "radio", className: inputCls, onChange: _this.handleChange }))));
        };
        return _this;
    }
    Object.defineProperty(Radio.prototype, "isChecked", {
        get: function () {
            return 'checked' in this.props ? this.props.checked : this.state.checked;
        },
        enumerable: false,
        configurable: true
    });
    Radio.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Radio;
}(React.Component));
exports.default = Radio;
Radio.defaultProps = {
    prefixCls: 'dui-radio',
    onChange: helper_1.emptyFn,
    hollow: true,
    labelClickable: true,
};
